import Button from 'components/base/Button';
import error500Illustration from 'assets/img/spot-illustrations/dark_500-illustration.png';
import dark500Illustration from 'assets/img/spot-illustrations/500-illustration.png';
import error500 from 'assets/img/spot-illustrations/500.png';
import darkError500 from 'assets/img/spot-illustrations/dark_500.png';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useSettingsMountEffect from 'hooks/useSettingsMountEffect';

// Error500 component is a React functional component that displays an "Internal Server Error" page (HTTP 500 error).
// The page includes error illustrations for both light and dark modes, and a button that allows the user to navigate back to the homepage.
const Error500 = () => {
  // useSettingsMountEffect is a custom hook that disables certain UI elements when the component is mounted.
  // This is done to focus on displaying the error page by removing unnecessary elements like navigation bars.
  useSettingsMountEffect({
    disableNavigationType: true,
    disableHorizontalNavbarAppearance: true,
    disableVerticalNavbarAppearance: true,
    disableHorizontalNavbarShape: true
  });

  return (
    <div>
      <div className="px-3">
        {/* Container for the error page content */}
        <Row className="min-vh-100 flex-center p-5">
          <Col xs={12} xl={10} xxl={8}>
            {/* This row contains the error illustrations and the message */}
            <Row className="justify-content-center  g-5">
              {/* Left column for displaying error illustrations */}
              <Col xs={12} lg={6} className="text-center order-lg-1">
                {/* Error illustrations for dark and light modes */}
                <img
                  src={error500Illustration}
                  alt=""
                  width={400}
                  className="img-fluid w-md-50 w-lg-100 d-dark-none"
                />
                <img
                  src={dark500Illustration}
                  alt=""
                  width={540}
                  className="img-fluid w-lg-100 d-light-none"
                />
              </Col>

              {/* Right column for displaying the error message and action button */}
              <Col xs={12} lg={6} className="text-center text-lg-start">
                {/* Error illustrations for dark and light modes */}
                <img
                  src={error500}
                  className="img-fluid mb-6 w-50 w-lg-75 d-dark-none"
                  alt=""
                />
                <img
                  src={darkError500}
                  className="img-fluid mb-6 w-50 w-lg-75 d-light-none"
                  alt=""
                />

                {/* Error message*/}
                <h2 className="text-body-secondary fw-bolder mb-3">
                  Internal Error!
                </h2>

                <p className="text-body mb-5">
                  Uh-oh! It seems like our server is taking an unexpected coffee
                  break.
                </p>

                {/* Button for navigating the user back to the homepage */}
                <Button variant="primary" size="lg" as={Link} to="/">
                  Go Home
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Error500;
